import { render, staticRenderFns } from "./common-modal.vue?vue&type=template&id=ff53b4be"
import script from "./common-modal.vue?vue&type=script&lang=js"
export * from "./common-modal.vue?vue&type=script&lang=js"
import style0 from "./common-modal.vue?vue&type=style&index=0&id=ff53b4be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports